export default __webpack_public_path__ + "static/media/945.b055a588.png";